<script lang="ts">
  import { onMount } from 'svelte';
  import { location } from 'svelte-spa-router';
  import RepositoryFactory, { INVITATION_UMOBILED } from '../../../repositories/RepositoryFactory';
  import { FetchRegisteredInvitationTransferApplicationResult } from '../../../repositories/invitationumobiled';
  import NotFound from './NotFound.svelte';

  type TDisplay = 'RECEIVED' | 'ERROR';
  let display: TDisplay = 'RECEIVED';
  const transitionDisplay = (nextDisplay: TDisplay) => {
    display = nextDisplay;
  };

  $: $location;
  const param = $location.replace('/invitation/umobiled/received/', '');
  const params = param.split('/');
  if (params.length <= 2) {
    window.location.href = '/404.html';
  }
  const accessToken = params[0];
  const invitationCode = params[1];
  if (!accessToken || !invitationCode) {
    transitionDisplay('ERROR');
  }

  const repository = RepositoryFactory[INVITATION_UMOBILED];

  $: slnUrl = null;

  onMount(() => {
    repository
      .fetchRegisteredInvitationTransferApplication({ accessToken: accessToken, invitationCode: invitationCode })
      .then((response: FetchRegisteredInvitationTransferApplicationResult) => {
        if (response && response.slnUrl) {
          slnUrl = response.slnUrl;
        } else {
          transitionDisplay('ERROR');
        }
      })
      .catch((error) => {
        transitionDisplay('ERROR');
      });
  });
</script>

{#if display === 'RECEIVED'}
  <div class="flex flex-col justify-between items-center login-background">
    <header class="container top-0 z-0">
      <div class="justify-between items-center" style="height:56px">
        <img style="height:36px" class="object-none w-full" src="/image/unext_communication_logo.svg" alt="logo" />
      </div>
    </header>

    <main class="container mt-10 mb-auto">
      <div class="flex justify-center text-2xl">U-mobile(d)移管特別オファー申込ページ</div>

      <div class="flex justify-center mt-20">
        <div class="content-center shadow-sm p-2 lg:w-1/2 w-full">
          <div class="mb:font-sm w-full">
            <ul class="list-none">
              <li>
                <p>お申込みありがとうございます。</p>
              </li>
              <li>
                <p>お申込みはまだ完了していません。下記リンクよりクレジットカード情報をご登録ください。</p>
              </li>
              <li>
                <p>また、お申込みいただいた内容は、ご登録いただいたメールアドレスに送付させていただいております。</p>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="flex justify-center my-10">
        <div class="content-center shadow-sm p-4 form-background lg:w-1/2 w-full">
          <div class="content-help-title-xl text-center">クレジットカード情報登録</div>

          <div class="flex justify-center items-center border-2 border-gray-900 text-blue-700 p-4 my-5 w-full">
            <button
              class="tracking-widest text-center text-sm underline h-auto w-auto"
              on:click={() => (window.location.href = `${slnUrl}`)}
            >
              クレジットカード情報登録画面へ</button
            >
          </div>
        </div>
      </div>
    </main>

    <footer class="container" />
  </div>
{:else}
  <NotFound />
{/if}

<style lang="postcss">
  .login-background {
    background-color: white;
  }

  .content-help-title-xl {
    @apply text-xl font-semibold text-gray-900;
  }

  .form-background {
    background-color: rgba(0, 0, 0, 0.02);
  }
</style>
